export default __webpack_public_path__ + "static/media/5891_EDI_ok.b028777c.png";